import React from 'react';
import Authentication from './Authentication';
import Editorials from './Editorials';
import SocialMedia from './SocialMedia';

const RightsideBar = () => {
  return (
    <div className=''>
      <div className='sticky top-5'>
        <Authentication></Authentication>
        <SocialMedia></SocialMedia>
        <Editorials></Editorials>
      </div>
    </div>
  );
};

export default RightsideBar;